import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './components/containers/App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import '@openfonts/open-sans_all';
import { GlobalStyle } from './styles/global';
import './settings/i18n/i18n';

ReactDOM.render(
  <Provider store={store}>
    <GlobalStyle />
    <App />
  </Provider>,
  document.getElementById('root'),
);

serviceWorker.unregister();
